export default {
    en: {
      name: 'English',
      shortCode: 'en',
    },
    de: {
      name: 'Deutsch',
      shortCode: 'de',
    },
  };
  